﻿window.userpiketscheduler = function () {

    // Used to determ if a selection has been made when mouseUp.
    var dragdropselection = false;

    // Dragging (mouse) selection start datetime and stop datetime.
    var startSelection = Date.now();
    var stopSelection = Date.now();

    // selection function+userid ('3_32') and user for the new appointment (piket)
    var userServiceFunctionCombinedID = 0;

    // Selection of start and end datetime (kendo scheduler)
    var startDateScheduler = (moment().utc().unix() * 1000);
    var endDateScheduler = (moment().utc().add(1, 'days').unix() * 1000);

    // States (used to know what to do in certain situations)
    var deleteAppointment = false;
    var updateAppointment = false;
    var insertAppointment = false;
    var cancelAppointment = false;
    var eventChangeRunOnce = false;

    // scheduler data (public)
    var schedulerData = null;

    // selection of repeating the appointment
    var interval = 1;
    var frequantie = "None";
    var numberEvents = 0;
    var repeatUntil = Date.now();
    var mondaySelected = false;
    var tuesdaySelected = false;
    var wednesdaySelected = false;
    var thursdaySelected = false;
    var fridaySelected = false;
    var saterdaySelected = false;
    var sundaySelected = false;

    // refresh
    var redraw = true;
    var refreshData = true;

    // debugging
    var debug = false;

    // disable scheduler
    var _disable = false;

    var initialized = false;
    var isAdmin = false;

    function debugConsole(message) {
        if (debug) console.log(message);
    }

    function getDateTimeSelectionPiketScheduler() {
        var scheduler = $("#piket-scheduler").data("kendoScheduler");
        var startDate = moment()._d;
        var endDate = moment().add(1, 'days')._d;

        if (scheduler.view() != undefined) {
            startDate = scheduler.view().startDate();
            endDate = scheduler.view().endDate();

            var startTime = 0;
            var endTime = 0;

            if (scheduler.view().startTime) {
                //optionally add startTime / endTime of the view
                startTime = kendo.date.getMilliseconds(scheduler.view().startTime());
                endTime = kendo.date.getMilliseconds(scheduler.view().endTime());
                endTime = endTime == 0 ? kendo.date.MS_PER_DAY : endTime;
            }

            var result = {
                begin: new Date(startDate.getTime() - (startDate.getTimezoneOffset() * kendo.date.MS_PER_MINUTE) + startTime),
                end: new Date(endDate.getTime() - (endDate.getTimezoneOffset() * kendo.date.MS_PER_MINUTE) + endTime)
            }
        }

        return result;
    }

    function GetDateTimeKendo(date, time) {
        date = new Date(date);
        time = (time.getHours() * kendo.date.MS_PER_HOUR) +
            (time.getMinutes() * kendo.date.MS_PER_MINUTE) +
            (time.getSeconds() * 1000);

        if (!time) {
            time = kendo.date.MS_PER_DAY - 1;
        }

        date.setTime(date.getTime());

        return date;
    }

    function defineStartAndEndDateTimeSelection(e) {
        // Update selection while navigating (not working, not getting the new selection but the current selection -> start and end datetime)
        var view = e.sender.view();

        startDateScheduler = e.date.getTime();

        var scheduler = $("#piket-scheduler").data("kendoScheduler");
        view = scheduler.view();

        // Reset to begin of the day
        startDateScheduler = moment(startDateScheduler).startOf('day').unix() * 1000;

        // Great that Kendo does not give a end selection datetime. Use momentjs for the calculation of the end datetime.
        switch (e.view) {
            case "timelineWeek":

                if (e.action == "previous") {
                    startDateScheduler = moment(GetDateTimeKendo(view.startDate(), view.startTime()).getTime()).add(-7, 'days').unix() * 1000;
                    endDateScheduler = moment(GetDateTimeKendo(view.endDate(), view.endTime()).getTime()).add(-7, 'days').unix() * 1000;
                } else if (e.action == "next") {
                    startDateScheduler = moment(GetDateTimeKendo(view.startDate(), view.startTime()).getTime()).add(7, 'days').unix() * 1000;
                    endDateScheduler = moment(GetDateTimeKendo(view.endDate(), view.endTime()).getTime()).add(7, 'days').unix() * 1000;
                } else if (e.action == "changeView") {
                    startDateScheduler = moment(GetDateTimeKendo(view.startDate(), view.startTime()).getTime()).startOf('week').startOf('hour').unix() * 1000;
                    endDateScheduler = moment(GetDateTimeKendo(view.endDate(), view.endTime()).getTime()).add(7, 'days').unix() * 1000;
                }
                break;
            default:
                endDateScheduler = moment(startDateScheduler).add(1, 'days').unix() * 1000;
                break;
        }
    }

    // Given date not between 'no available'
    function isFree(date, userID) {
        debugConsole("Check before showing add dialog if the selection is free.");
        for (var i = 0; i < schedulerData.length; i++) {
            // Check if the owner is right (userID) and the planned appointment is indeed a not available appointment given by the older scheduler.
            if (schedulerData[i].OwnerID == userID && schedulerData[i].ServiceFunctionUser.split('_')[0] === '0') {
                var start = schedulerData[i].Start.match(/\d/g);
                start = parseInt(start.join(""));

                var end = schedulerData[i].End.match(/\d/g);
                end = parseInt(end.join(""));

                var time = date.getTime();

                if (time >= start && time <= end) {
                    // The user is not available
                    return false;
                }
            }
        }

        // The user is available
        return true;
    }

    // Final check if the use has drawn over a 'no available area', returns true if it does contain a periode of 'no available'. If not false.
    function startAndEndTimesContainNoAvailable(beginSelectionTime, endSelectionTime, userID) {
        for (var i = 0; i < schedulerData.length; i++) {
            // Check if the owner is right (userID) and the planned appointment is indeed a not available appointment given by the older scheduler.
            if (schedulerData[i].OwnerID == userID && schedulerData[i].ServiceFunctionUser.split('_')[0] === '0' ||  // not available
                schedulerData[i].OwnerID == userID && schedulerData[i].ServiceFunctionUser.split('_')[0] === '-1') { // adhoc not available
                var start = schedulerData[i].Start.match(/\d/g);
                start = parseInt(start.join(""));

                var end = schedulerData[i].End.match(/\d/g);
                end = parseInt(end.join(""));

                if (beginSelectionTime < start && endSelectionTime > end) {
                    // The user is not available
                    return false;
                }
            }
        }

        // The user is available
        return true;
    }

    // When creating a new piket, check if the user has already a planned piket on a other function
    function isNotAvailable(userServiceFunctionCombinedID, startSelection, stopSelection) {

        var scheduler = $("#piket-scheduler").data("kendoScheduler");
        var scheduled = scheduler.occurrencesInRange(startSelection, stopSelection);

        var result = false;
        scheduled.forEach(function (element) {
            if (element.AppointmentID === 0 && parseInt(element.ServiceFunctionUser.split('_')[1]) === parseInt(userServiceFunctionCombinedID.split('_')[1])) {
                result = true;
            }
        });

        return result;
    }

    // Find the selected values (weekdays array). Every selected day (checkbox) will return a value (integer)
    function findMatchWithValue(valueDay, myArray) {
        if (myArray !== undefined) {
            for (var i = 0; i < myArray.length; i++) {
                if (myArray[i].day === valueDay) {
                    return true;
                }
            }
        }
        return false;
    }

    // Called when the Recurrence settings change
    function updateRecurrenceVariables(event) {
        var changedValues = event.sender._value;

        var endAfterCountIsChecked = $('input[class~="k-recur-end-count"]:checked')[0] != undefined;
        var endAfterDateIsChecked = $('input[class~="k-recur-end-until"]:checked')[0] != undefined;

        if (changedValues.freq === "weekly") {
            $(".k-recur-end-never").closest("li").hide();
            $("#endPiket").hide();
        } else {
            $("#endPiket").show();
        }

        if (endAfterCountIsChecked) {
            numberEvents = changedValues.count;
        } else {
            numberEvents = 0;
        }

        if (changedValues.interval === undefined) {
            changedValues.interval = 1;
        }
        if (changedValues.until !== undefined && changedValues.until !== null) {
            repeatUntil = changedValues.until.getTime();
        }

        interval = changedValues.interval;
        frequantie = changedValues.freq;

        mondaySelected = findMatchWithValue(1, changedValues.weekDays);
        tuesdaySelected = findMatchWithValue(2, changedValues.weekDays);
        wednesdaySelected = findMatchWithValue(3, changedValues.weekDays);
        thursdaySelected = findMatchWithValue(4, changedValues.weekDays);
        fridaySelected = findMatchWithValue(5, changedValues.weekDays);
        saterdaySelected = findMatchWithValue(6, changedValues.weekDays);
        sundaySelected = findMatchWithValue(0, changedValues.weekDays);

        if (changedValues.freq === "weekly" && !endAfterCountIsChecked && !endAfterDateIsChecked) {
            $("button[class~='k-scheduler-update']").attr("disabled", "disabled");
        }
        else {
            $("button[class~='k-scheduler-update']").removeAttr("disabled");
        }
    }

    /**
    * Get the settings filled in the generated form. 
    * @param {any} amountOfDays
    */
    function GetShiftWorkDaySettings(amountOfDays) {
        var arrFromTo = [];

        // Loop through input fields for the repeated moments.
        for (var row = 1; row <= amountOfDays; row++) {

            for (var numMoment = 1; numMoment <= 3; numMoment++) {
                var valueResult = ($("#" + row + "_" + numMoment + "_From").data("kendoTimePicker") != undefined &&
                    $("#" + row + "_" + numMoment + "_From").data("kendoTimePicker").value() != null &&
                    $("#" + row + "_" + numMoment + "_To").data("kendoTimePicker") != undefined &&
                    $("#" + row + "_" + numMoment + "_To").data("kendoTimePicker").value() != null);

                if (valueResult) {                    
                    var obj = {
                        Day: row,
                        MomentNbr: numMoment,
                        TimeFrom: ($("#" + row + "_" + numMoment + "_From").data("kendoTimePicker").value().getHours() * 60) + $("#" + row + "_" + numMoment + "_From").data("kendoTimePicker").value().getMinutes(),
                        TimeTo: ($("#" + row + "_" + numMoment + "_To").data("kendoTimePicker").value().getHours() * 60) + $("#" + row + "_" + numMoment + "_To").data("kendoTimePicker").value().getMinutes()
                    };

                    arrFromTo.push(obj);
                }
            }
        }

        return arrFromTo;
    }

    /**
    * Submit formshift (custom and not handled by the taghelper because of the dynamic generated form and values presented in the form)
    * @param {any} e
    */
    function onFormSubmit_FormShift(e) {
        // Prevent default behaviour
        e.preventDefault();
        var groupId = parseInt($("#selectedGroupId").data("kendoDropDownList").value());

        // Post Data
        $.ajax({
            type: "POST",
            url: appsettings.getUrl("UserScheduler/SaveSettingsShifts"),
            data: {
                ShiftWorkID: e.model.ShiftWorkID,
                UserID: e.model.UserID,
                AmountOfDays: e.model.AmountOfDays,
                ShiftType: parseInt(e.model.ShiftType),
                StartDate: e.model.StartDate,
                EndDate: e.model.EndDate,
                ShiftWorkDays: GetShiftWorkDaySettings(e.model.AmountOfDays),
                SchedulerType: 2, // PiketScheduler
                IsAdmin: e.model.IsAdmin
            },
            success: function (responseData) {
                if (responseData.Succesfully) {
                    $('#ShiftWorkID').val(responseData.Id);

                    // Post Data
                    $.ajax({
                        type: "GET",
                        url: appsettings.getUrl("UserPiketScheduler/FormShift?userId=" + e.model.UserID + "&groupId=" + groupId),

                        success: function (responseData) {
                            $("#PloegenScheduleWindow").html(responseData);
                        }
                    });

                    form.showServerResponse(responseData);
                } else {
                    $('#ShiftWarning').text(responseData.Message)
                }
            }
        });
    }

    return {
        initialize: function (disabled) {

            _disable = disabled;

            refreshData = true;
            redraw = true;

            if (_disable) {
                $("#piket-scheduler").attr("disabled", "disabled");
            } else {
                $("#piket-scheduler").removeAttr("disabled");
            }

            //Open ploegen schedule
            $("#showPloegenSchedulerDialogBtn").click(function () {
                $("#PloegenScheduleWindow").data("kendoWindow").center().open();
            });
        },

        getDateTimeKendo: function (date, time) {
            date = new Date(date);
            time = (time.getHours() * kendo.date.MS_PER_HOUR) +
                (time.getMinutes() * kendo.date.MS_PER_MINUTE) +
                (time.getSeconds() * 1000);

            if (!time) {
                time = kendo.date.MS_PER_DAY - 1;
            }

            date.setTime(date.getTime());

            return date;
        },

        onAdd: function (e) {
            // Selection (has an appointment already, cannot plan another appointment/piket)
            var appointmentInSelectedUserFunction = false;
            var scheduler = $("#piket-scheduler").data("kendoScheduler");
            var scheduled = scheduler.occurrencesInRange(startSelection, stopSelection);

            scheduled.forEach(function (element) {
                if (element.ServiceFunctionUser === userServiceFunctionCombinedID) {
                    appointmentInSelectedUserFunction = true;
                }
            });

            if (appointmentInSelectedUserFunction) {
                e.preventDefault();
            }
        },

        onNavigate: function (e) {
            var scheduler = $("#piket-scheduler").data("kendoScheduler");
            scheduler.select(null);

            defineStartAndEndDateTimeSelection(e);

            // Allow to refresh the background and get new data 
            refreshData = true;
            redraw = true;
        },

        onEdit: function (e) {
            var container = e.container;
            var recurrenceEditor = container.find("[data-role=recurrenceeditor]")
                .data("kendoRecurrenceEditor");

            if (e.event.appointmentId == 0) {
                //If new apointment
                $("#takeover").hide();
                $("#RepeatPiket").show();
            } else {
                //Get possible users for take over
                var dataSource = new kendo.data.DataSource({
                    transport: {
                        read: {
                            url: appsettings.getUrl("UserPiketScheduler/GetFunctionUsers") + "?appointmentId=" + e.event.appointmentId,
                            contentType: 'application/json; charset=utf-8'
                        }
                    },
                    schema: {
                        data: function (response) {
                            var functionUsers = [];
                            for (var i = 0; i < response.length; i++) {
                                var functionUser = {
                                    Value: response[i].UserID,
                                    Text: response[i].FullName
                                };
                                functionUsers.push(functionUser);
                            }
                            return functionUsers;
                        }
                    },
                });
                $("#usersDropdown").kendoDropDownList({
                    dataTextField: "Text",
                    dataValueField: "Value",
                    dataSource: dataSource
                });

                var dropdownlist = $("#usersDropdown").data("kendoDropDownList");
                if (dropdownlist !== undefined) {
                    dropdownlist.one("dataBound", () => {
                        dropdownlist.select(function (dataItem) {
                            return dataItem.Value === e.event.ownerId;
                        });
                    });
                }

                $("#users").hide();
                $("#allgroups").prop("checked", e.event.isAllGroups);
                $("#allgroups").attr("disabled", "disabled");
                $("#allgroups").removeClass("k-checkbox");
                $("#allgroups").addClass("k-checkbox-disabled");

                $("#RepeatPiket").hide();
            }

            recurrenceEditor.bind("change", function (e) {
                updateRecurrenceVariables(e);
            });

            // reset local vars
            interval = 1;
            frequantie = "None";
            numberEvents = 0;
            repeatUntil = Date.now();
            mondaySelected = false;
            tuesdaySelected = false;
            wednesdaySelected = false;
            thursdaySelected = false;
            fridaySelected = false;
            saterdaySelected = false;
            sundaySelected = false;
        },

        onSave: function () {
            redraw = true;
            refreshData = true;
        },
        onRemove: function () {
            redraw = true;
            refreshData = true;
        },

        onCancel: function (e) {
            cancelAppointment = true;
        },

        onError: function (args) {
            //The event will fire when there are ModelState errors.
            var errors = args.errors; //Get the received errors.
            var message = "";
            var scheduler = $("#piket-scheduler").data("kendoScheduler");
            if (errors) {
                scheduler.one("dataBinding", function (e) { //Subscribe to the "dataBinding" event of the Scheduler once.
                    e.preventDefault(); //prevent the default event action
                    $.each(errors, function (key, value) { //loop through the errors
                        if ('errors' in value) {
                            $.each(value.errors, function () {
                                message += this + "\n"; //Store the message in a variable
                            });
                        }

                        // As long as the key matches the field name, this line of code will be displayed as validation message in the popup.
                        //scheduler.editable.element.find("[data-for='" + key + "'].k-invalid-msg").replaceWith('<div class="k-widget k-tooltip k-tooltip-error" style="margin:0.5em"><span class="k-icon k-font-icon k-i-warning"> </span>' + message + '<div class="k-callout k-callout-n"></div></div>').show();
                        $("#EWarning").text(message);
                    });
                });
            }
        },

        changeHeightScheduler: function (h, maxh) {
            if (h < maxh) {
                $("#piket-scheduler").data("kendoScheduler").element.height(h);
            } else {
                $("#piket-scheduler").data("kendoScheduler").element.height(maxh);
            }
            $("#piket-scheduler").data("kendoScheduler").resize(true);
        },

        // get the user functions for the new selected group
        onChangeGroupId: function (e) {

            var groupId = e.sender.value();
            var selection = getDateTimeSelectionPiketScheduler();

            $.ajax({
                type: "GET",
                url: appsettings.getUrl("UserPiketScheduler/GetUserFunctions") + "?groupId=" + groupId + "&begin=" + selection.begin.getTime() + "&end=" + selection.end.getTime(),
                success: function (responseData) {

                    _disable = responseData.Disabled;

                    if (_disable) {
                        $("#piket-scheduler").attr("disabled", "disabled");
                    } else {
                        $("#piket-scheduler").removeAttr("disabled");
                    }

                    // replenish the data resources
                    $("#piket-scheduler").data("kendoScheduler").resources[0].dataSource.transport.data = responseData.SchedulerResources;

                    // Reset var to redraw the background of the scheduler.
                    redraw = true;
                    refreshData = true;

                    // after replenish, read/construct new userfunctions and read new data from the scheduler. 
                    $("#piket-scheduler").data("kendoScheduler").resources[0].dataSource.read();
                    $("#piket-scheduler").data("kendoScheduler").dataSource.read();
                }
            });
            window.userpiketscheduler.getGroupUsers(groupId);
        },

        // Schedular change
        scheduler_change: function (e) {
            startSelection = e.start;
            stopSelection = e.end;
            userServiceFunctionCombinedID = e.resources.ServiceFunctionUser;

            if (eventChangeRunOnce === false) {
                if (e.events.length === 0 && deleteAppointment === false && updateAppointment === false && insertAppointment === false && cancelAppointment === false) {
                    dragdropselection = true;
                } else {
                    // set false
                    deleteAppointment = false;
                    updateAppointment = false;
                    insertAppointment = false;
                    cancelAppointment = false;

                    // run the event change not for a second time !
                    eventChangeRunOnce = true;
                }
            } else {
                // deselect all selections in the scheduler (if any)
                eventChangeRunOnce = false;
            }
        },

        // When creating a new piket, check if the user has already a planned piket on a other function
        isPlannedAlreadyForOtherFunction: function (userServiceFunctionCombinedID, startSelection, stopSelection) {
            var scheduler = $("#piket-scheduler").data("kendoScheduler");
            var scheduled = scheduler.occurrencesInRange(startSelection, stopSelection);

            var result = false;
            scheduled.forEach(function (element) {
                if (element.appointmentId !== 0) {
                    if (parseInt(element.ServiceFunctionUser.split('_')[1]) === parseInt(userServiceFunctionCombinedID.split('_')[1])) {
                        result = true;
                    }
                }
            });

            return result;
        },

        // Fired up when the mouse button is released. Checks if any action is needed.
        mouseUp: function () {

            if (userServiceFunctionCombinedID !== "" && dragdropselection && isFree(startSelection, parseInt(userServiceFunctionCombinedID.split('_')[1])) && isFree(stopSelection, parseInt(userServiceFunctionCombinedID.split('_')[1])) && startAndEndTimesContainNoAvailable(startSelection, stopSelection, parseInt(userServiceFunctionCombinedID.split('_')[1]))) {
                var scheduler = $("#piket-scheduler").data("kendoScheduler");
                var scheduled = scheduler.occurrencesInRange(startSelection, stopSelection);

                // Selection (has an appointment already, cannot plan another appointment/piket)
                var appointmentInSelectedUserFunction = false;

                scheduled.forEach(function (element) {
                    if (element.ServiceFunctionUser === userServiceFunctionCombinedID) {
                        appointmentInSelectedUserFunction = true;
                    }
                });

                // Cannot add on
                if (scheduled && !appointmentInSelectedUserFunction) {
                    if (!isNotAvailable(userServiceFunctionCombinedID, startSelection, stopSelection)) {
                        scheduler.addEvent({ title: "", start: startSelection, end: stopSelection, ServiceFunctionUser: userServiceFunctionCombinedID });
                        dragdropselection = false;

                        $("#enddate").change(function (e) {
                            // als eind kleiner is dan de begin datum correctie
                            if (moment($('#enddate').data("kendoDateTimePicker").value()).unix() <
                                moment($('#begindate').data("kendoDateTimePicker").value()).unix()) {
                                var begindate = moment($('#begindate').data("kendoDateTimePicker").value());
                                var newdate = begindate.add(1, 'days')._d;
                                $('#enddate').data("kendoDateTimePicker").value(newdate);
                            }
                        });
                        $("#begindate").change(function (e) {
                            // als eind kleiner is dan de begin datum correctie
                            if (moment($('#enddate').data("kendoDateTimePicker").value()).unix() <
                                moment($('#begindate').data("kendoDateTimePicker").value()).unix()) {
                                var enddate = moment($('#enddate').data("kendoDateTimePicker").value());
                                var newdate = enddate.subtract(1, 'days')._d;
                                $('#begindate').data("kendoDateTimePicker").value(newdate);
                            }
                        });

                        // reset local vars
                        var interval = 1;
                        var frequantie = "None";
                        var numberEvents = 0;
                        var repeatUntil = Date.now();
                        var mondaySelected = false;
                        var tuesdaySelected = false;
                        var wednesdaySelected = false;
                        var thursdaySelected = false;
                        var fridaySelected = false;
                        var saterdaySelected = false;
                        var sundaySelected = false;
                    }
                }
            }
        },

        scheduler_redraw: function (e) {
            if (redraw) {
                var schedulerPiket = $("#piket-scheduler").data("kendoScheduler");
                schedulerPiket.view(schedulerPiket.view().name);
                redraw = false;
                refreshData = false;
            }
        },

        // Paint the background with some color
        getColorBasedOnHour: function (date, resources) {

            // Get current data from the scheduler.
            schedulerData = $("#piket-scheduler").data("kendoScheduler").dataSource.data();

            // Check if the data is received.
            if (schedulerData != null
                && schedulerData != undefined
                && resources.ServiceFunctionUser != null
                && resources.ServiceFunctionUser != undefined
                && schedulerData.length > 0) {

                for (var i = 0; i < schedulerData.length; i++) {

                    // Get userId
                    var userID = parseInt(resources.ServiceFunctionUser.split('_')[1]);

                    if (schedulerData[i].ownerId == userID && schedulerData[i].ServiceFunctionUser.split('_')[0] === '-1') {

                        var start = new Date(Date.parse(schedulerData[i].start));
                        var end = new Date(Date.parse(schedulerData[i].end));

                        var time = date.getTime();

                        if (time >= start && time < end) {
                            // Is NOT available
                            return "k-schedule-hour-notavailableadhoc";
                        }
                    }

                    // Check if the owner is right (userID) and the planned appointment is indeed a not available appointment given by the older scheduler.
                    if (schedulerData[i].ownerId == userID && schedulerData[i].ServiceFunctionUser.split('_')[0] === '0') {

                        var start = new Date(Date.parse(schedulerData[i].start));
                        var end = new Date(Date.parse(schedulerData[i].end));

                        var time = date.getTime();

                        if (time >= start && time < end) {
                            // Is NOT available
                            return "k-schedule-hour-notavailable";
                        }
                    }
                }

            }

            // Is available
            return "k-schedule-hour-available";
        },

        getAdditionalData: function () {
            var piketScheduler = getDateTimeSelectionPiketScheduler();

            return {
                begin: piketScheduler.begin,
                end: piketScheduler.end,
                groupId: parseInt($("#selectedGroupId").data("kendoDropDownList").value()),
                refreshData: refreshData
            }
        },

        createPiketAdditionalData: function (e) {

            return {
                groupId: parseInt($("#selectedGroupId").data("kendoDropDownList").value()),
                begin: $('#begindate').data("kendoDateTimePicker").value().getTime(),
                end: $('#enddate').data("kendoDateTimePicker").value().getTime(),
                until: repeatUntil,
                numberEvents: numberEvents,
                isWeeklyRepeat: frequantie === "weekly",
                repeatEveryNumberOfWeeks: $("#recur_interval").length > 0 ? $("#recur_interval").data("kendoNumericTextBox").value() : 1,
                isSelectedMonday: mondaySelected,
                isSelectedTuesday: tuesdaySelected,
                isSelectedWednesday: wednesdaySelected,
                isSelectedThursday: thursdaySelected,
                isSelectedFriday: fridaySelected,
                isSelectedSaterday: saterdaySelected,
                isSelectedSunday: sundaySelected
            }

        },

        updatePiketAdditionalData: function (e) {
            var usersDropdownList = $("#usersDropdown").data("kendoDropDownList");
            var takeover = false;

            if (usersDropdownList) {
                var newUser = parseInt(usersDropdownList.value());
            }
            if (newUser != undefined && newUser != e.OwnerID && $("#users").is(":visible")) {
                takeover = true;
            }
            return {
                groupId: parseInt($("#selectedGroupId").data("kendoDropDownList").value()),
                ScheduleAppointmentID: e.AppointmentID,
                serviceFunctionUser: e.ServiceFunctionUser,
                begin: e.Start.getTime(),
                end: e.End.getTime(),
                TakeOver: takeover,
                UserID: newUser
            }
        },

        deletePiketAdditionalData: function (e) {
            return {
                ScheduleAppointmentID: e.AppointmentID,
            }
        },

        onClickTakeOver: function () {
            var visible = $("#users").is(":visible");
            if (visible == true) {
                $("#RepeatPiket").show();
                $("#PiketWarning").show();
                $("#users").hide();
            } else {
                $("#RepeatPiket").hide();
                $("#PiketWarning").hide();
                $("#users").show();
            }
        },

        initFormShiftWork: function () {
            //Get users from selected group
            var groupId = parseInt($("#selectedGroupId").data("kendoDropDownList").value());
            this.getGroupUsers(groupId);

            $("#usersDropdownList").on("change", this.getSelectedUserFunctions);

            var dropdownlist = $("#usersDropdownList").data("kendoDropDownList");
            if (dropdownlist !== undefined) {
                dropdownlist.one("dataBound", () => {
                    this.getSelectedUserFunctions();
                    initialized = false;
                    var users = $("#usersDropdownList").data("kendoDropDownList").items();
                    if (users.length > 1) {
                        isAdmin = true;
                    }
                    if (!isAdmin) {
                        var startDateTimePicker = $("#StartDate").data("kendoDateTimePicker");
                        if (startDateTimePicker != undefined) {
                            var now = new Date(Date.now());
                            var round = kendo.date.MS_PER_MINUTE * 15;
                            var date = new Date(Math.floor(now.getTime() / round) * round);
                            startDateTimePicker.min(date);
                        }
                    }
                });
            }

            $("#SchedulePlanningButtonLoader").hide();

            $("#SchedulePlanningButton").click(function () {
                $("#SchedulePlanningButtonLoader").show();

                var userId = parseInt($("#usersDropdownList").data("kendoDropDownList").value());

                //Post Data
                $.ajax({
                    type: "POST",
                    url: appsettings.getUrl("UserPiketScheduler/PlanShifts"),
                    data: {
                        ShiftWorkID: -1,
                        UserID: userId,
                        AmountOfDays: $("#AmountOfDays").data("kendoNumericTextBox").value(),
                        ShiftType: parseInt($("#ShiftType").data("kendoDropDownList").value()),
                        StartDate: $("#StartDate").data("kendoDateTimePicker").value().toDateString(),
                        EndDate: $("#EndDate").data("kendoDateTimePicker").value().toDateString(),
                        ShiftWorkDays: GetShiftWorkDaySettings($("#AmountOfDays").data("kendoNumericTextBox").value()),
                        //Extra piket data
                        SchedulerType: 2, // PiketScheduler
                        SelectedFunction: parseInt($("#functionsDropdownList").data("kendoDropDownList").value()),
                        GroupId: parseInt($("#selectedGroupId").data("kendoDropDownList").value()),
                        IsAdmin: isAdmin
                    },
                    success: function (responseData) {
                        if (responseData.Succesfully) {
                            redraw = true;
                            refreshData = true;

                            $("#piket-scheduler").data("kendoScheduler").dataSource.read();   // refresh scheduler

                            $("#SchedulePlanningButtonLoader").hide();

                            $('#ShiftWarning').text("")
                            //Close dialog
                            $("#PloegenScheduleWindow").data("kendoWindow").close();
                        } else {
                            $("#SchedulePlanningButtonLoader").hide();
                            $('#ShiftWarning').text(responseData.Message)
                        }
                    },

                    error: function () {
                        $("#SchedulePlanningButtonLoader").hide();
                    }
                });
            });

            // Form Submit ajax call
            $('#formUserScheduler_FormShift').submit(function (event) {
                // Prevent default
                event.preventDefault();

                // Make model to send.
                var vm = {}
                vm.preventDefault = event.preventDefault

                var startDate = $(event.currentTarget).find("#StartDate").data("kendoDateTimePicker").value(); 
                var endDate= $(event.currentTarget).find("#EndDate").data("kendoDateTimePicker").value();
                var startDateString = null;
                var endDateString = null;

                if (startDate != null) {
                    startDateString = startDate.toUTCString();
                }
                if (endDate != null) {
                    endDateString = endDate.toUTCString();
                }

                // Model
                vm.model = {
                    ShiftWorkID: parseInt($('#ShiftWorkID').val()),
                    AmountOfDays: parseInt($(event.currentTarget).find("#AmountOfDays").val()),
                    ShiftType: parseInt($(event.currentTarget).find("#ShiftType").val()),
                    StartDate: startDateString,
                    EndDate: endDateString,
                    UserID: parseInt($("#usersDropdownList").data("kendoDropDownList").value()),
                    IsAdmin: isAdmin
                };

                // Fire event
                onFormSubmit_FormShift(vm);
            });

            // Set validation config
            $('#formUserScheduler_FormShift').kendoValidator(window.validation.getConfiguration());
        },
        
        getGroupUsers: function (groupId) {
            var dataSource =  new kendo.data.DataSource({
                transport: {
                    read: {
                        url: appsettings.getUrl("UserPiketScheduler/GetGroupUsers") + "?groupId=" + groupId,
                        contentType: 'application/json; charset=utf-8'
                    }
                },
                schema: {
                    data: function (response) {
                        var users = [];
                        for (var i = 0; i < response.length; i++) {
                            var user = {
                                Value: response[i].UserID,
                                Text: response[i].FullName
                            };
                            users.push(user);
                        }
                        return users;
                    }
                },
            });
            
            $("#usersDropdownList").kendoDropDownList({
                dataTextField: "Text",
                dataValueField: "Value",
                dataSource: dataSource,
                filter: "contains"
            });
        },

        getSelectedUserFunctions: function () {
            //Get functions of the selected user in the selected group
            var userId = parseInt($("#usersDropdownList").data("kendoDropDownList").value());
            var groupId = parseInt($("#selectedGroupId").data("kendoDropDownList").value());
            var dataSource = new kendo.data.DataSource({
                transport: {
                    read: {
                        url: appsettings.getUrl("UserPiketScheduler/GetSelectedUserFunctions") + "?userId=" + userId + "&groupId=" + groupId,
                        contentType: 'application/json; charset=utf-8',
                        type: "GET"
                    }
                },
                schema: {
                    data: function (response) {
                        var functions = [];
                        for (var i = 0; i < response.length; i++) {
                            var func = {
                                Value: response[i].ServiceFunctionID,
                                Text: response[i].Label
                            };
                            functions.push(func);
                        }
                        return functions;
                    }
                },
            });
            $("#functionsDropdownList").kendoDropDownList({
                dataTextField: "Text",
                dataValueField: "Value",
                dataSource: dataSource
            });

            if (!initialized) {
                $.ajax({
                    type: "GET",
                    url: appsettings.getUrl("UserPiketScheduler/FormShift?userId=" + userId + "&groupId=" + groupId),

                    success: function (responseData) {
                        initialized = true;
                        $("#PloegenScheduleWindow").html(responseData);
                    }
                });
            }
        },
    }
}();